module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_innlandet_pos.0adb88e0.pdf";